import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './FounderPage.css';

const Reveal = ({ children, delay = 0, className = '' }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 40 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

const FounderNew = () => {
  const navigate = useNavigate();

  return (
    <div className="founder-page" data-testid="founder-page">
      <SEO
        title="Veda Lolge | Founder, The Prisma Global"
        description="I don't build companies. I build systems that generate them."
        canonical="/founder"
      />

      <Navbar />

      <section className="founder-hero" data-testid="founder-hero">
        <div className="founder-hero-inner">
          <div className="founder-portrait-col">
            <motion.div
              className="founder-portrait-wrapper"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.3, duration: 1, ease: [0.22, 1, 0.36, 1] }}
            >
              <img
                src="/founder-portrait.webp"
                alt="Veda Lolge — Founder, Prisma Global"
                className="founder-portrait"
                data-testid="founder-portrait"
              />
              <div className="portrait-overlay" />
            </motion.div>
          </div>

          <div className="founder-text-col">
            <motion.div
              className="founder-identity"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
            >
              <span className="founder-label">Founder</span>
              <h2 className="founder-name">Veda Lolge</h2>
              <span className="founder-title">Founder, Prisma Global</span>
            </motion.div>

            <motion.h1
              className="founder-headline"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 1, ease: [0.22, 1, 0.36, 1] }}
            >
              I don't build companies.
            </motion.h1>
            <motion.p
              className="founder-accent"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.1, duration: 0.8 }}
            >
              I build systems that generate them.
            </motion.p>
          </div>
        </div>
      </section>

      <section className="founder-body" data-testid="founder-body">
        <div className="founder-inner">
          <Reveal>
            <div className="founder-text">
              <p>Prisma Global is not a single venture.</p>
              <p>It is an evolving ecosystem&mdash;spanning apparel, technology, infrastructure, and cultural products&mdash;designed to scale ideas into assets.</p>
              <p>From government-linked initiatives to international pilots, the focus remains the same:</p>
              <p className="founder-emphasis">Build things that outlast their origin.</p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="founder-closing" data-testid="founder-closing">
        <div className="founder-inner">
          <Reveal>
            <h2 className="founder-close-line">This is not expansion.</h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="founder-close-accent">This is architecture.</p>
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FounderNew;
